<template>
<footer class="main-footer">

  
    <strong> Unlimited Recharge (UDR) </strong>

</footer>
</template>


<script>
export default {
    name: 'Pie'
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Pie.vue